window.HS_SWATCH_DATA = window.HS_SWATCH_DATA || {};
window.HS_SWATCH_DATA["zebra-blackout"] = {
  "product_key": "zebra-blackout",
  "minimum_order_quantity": 5,
  "tier_guide": [
    {
      "tier": "Tier 1",
      "label": "Budget Friendly"
    },
    {
      "tier": "Tier 2",
      "label": "Residential Collection"
    },
    {
      "tier": "Tier 3",
      "label": "Premium Collection"
    },
    {
      "tier": "Tier 4",
      "label": "Luxury Collection"
    }
  ],
  "swatches": [
    {
      "id": "zebra-blackout-DB1-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB1",
      "fabric_code": "DB1-001",
      "web_name": "Polar Snow Linen",
      "name_key": "polar-snow-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjEtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB1-1.jpg",
      "search_text": "DB1-001 Polar Snow Linen Budget Friendly",
      "sort_order": 368,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB1-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB1",
      "fabric_code": "DB1-002",
      "web_name": "Frost Veil Linen",
      "name_key": "frost-veil-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjEtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB1-2.jpg",
      "search_text": "DB1-002 Frost Veil Linen Budget Friendly",
      "sort_order": 369,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB1-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB1",
      "fabric_code": "DB1-003",
      "web_name": "Amber Ivory Linen",
      "name_key": "amber-ivory-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjEtMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB1-3.jpg",
      "search_text": "DB1-003 Amber Ivory Linen Budget Friendly",
      "sort_order": 370,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB1-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB1",
      "fabric_code": "DB1-004",
      "web_name": "Pearl Mist Linen",
      "name_key": "pearl-mist-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjEtNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB1-4.jpg",
      "search_text": "DB1-004 Pearl Mist Linen Budget Friendly",
      "sort_order": 371,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB3-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB3",
      "fabric_code": "DB3-001",
      "web_name": "Sahara Sand Linen",
      "name_key": "sahara-sand-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjMtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB3-1.jpg",
      "search_text": "DB3-001 Sahara Sand Linen Budget Friendly",
      "sort_order": 372,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB3-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB3",
      "fabric_code": "DB3-002",
      "web_name": "Almond Haze Linen",
      "name_key": "almond-haze-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjMtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB3-2.jpg",
      "search_text": "DB3-002 Almond Haze Linen Budget Friendly",
      "sort_order": 373,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB3-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB3",
      "fabric_code": "DB3-003",
      "web_name": "Oat Meadow Linen",
      "name_key": "oat-meadow-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjMtMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB3-3.jpg",
      "search_text": "DB3-003 Oat Meadow Linen Budget Friendly",
      "sort_order": 374,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB3-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB3",
      "fabric_code": "DB3-004",
      "web_name": "Stonewash Linen",
      "name_key": "stonewash-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjMtNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB3-4.jpg",
      "search_text": "DB3-004 Stonewash Linen Budget Friendly",
      "sort_order": 375,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB3-005",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB3",
      "fabric_code": "DB3-005",
      "web_name": "Greige Harmony Linen",
      "name_key": "greige-harmony-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjMtNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB3-5.jpg",
      "search_text": "DB3-005 Greige Harmony Linen Budget Friendly",
      "sort_order": 376,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB3-006",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB3",
      "fabric_code": "DB3-006",
      "web_name": "Taupe Meadow Linen",
      "name_key": "taupe-meadow-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjMtNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB3-6.jpg",
      "search_text": "DB3-006 Taupe Meadow Linen Budget Friendly",
      "sort_order": 377,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB3-007",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB3",
      "fabric_code": "DB3-007",
      "web_name": "Cocoa Dusk Weave",
      "name_key": "cocoa-dusk-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjMtNy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB3-7.jpg",
      "search_text": "DB3-007 Cocoa Dusk Weave Budget Friendly",
      "sort_order": 378,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB4-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB4",
      "fabric_code": "DB4-001",
      "web_name": "Dove Whisper Linen",
      "name_key": "dove-whisper-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjQtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB4-1.jpg",
      "search_text": "DB4-001 Dove Whisper Linen Budget Friendly",
      "sort_order": 379,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB4-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB4",
      "fabric_code": "DB4-002",
      "web_name": "Mist Harbour Linen",
      "name_key": "mist-harbour-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjQtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB4-2.jpg",
      "search_text": "DB4-002 Mist Harbour Linen Budget Friendly",
      "sort_order": 380,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB4-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB4",
      "fabric_code": "DB4-003",
      "web_name": "Silver Halo Linen",
      "name_key": "silver-halo-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjQtMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB4-3.jpg",
      "search_text": "DB4-003 Silver Halo Linen Budget Friendly",
      "sort_order": 381,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB4-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB4",
      "fabric_code": "DB4-004",
      "web_name": "Graphite Night Weave",
      "name_key": "graphite-night-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjQtNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9177220317403-DB4-4.jpg",
      "search_text": "DB4-004 Graphite Night Weave Budget Friendly",
      "sort_order": 382,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB11-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB11",
      "fabric_code": "DB11-001",
      "web_name": "Cloud Breeze Linen",
      "name_key": "cloud-breeze-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjExLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB11-1.jpg",
      "search_text": "DB11-001 Cloud Breeze Linen Budget Friendly",
      "sort_order": 383,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB11-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB11",
      "fabric_code": "DB11-002",
      "web_name": "Classic Ivory Linen",
      "name_key": "classic-ivory-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjExLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB11-2.jpg",
      "search_text": "DB11-002 Classic Ivory Linen Budget Friendly",
      "sort_order": 384,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB13-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB13",
      "fabric_code": "DB13-001",
      "web_name": "Ash Horizon Linen",
      "name_key": "ash-horizon-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjEzLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB13-1.jpg",
      "search_text": "DB13-001 Ash Horizon Linen Budget Friendly",
      "sort_order": 385,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB13-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB13",
      "fabric_code": "DB13-002",
      "web_name": "Smoke Ridge Weave",
      "name_key": "smoke-ridge-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjEzLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB13-2.jpg",
      "search_text": "DB13-002 Smoke Ridge Weave Budget Friendly",
      "sort_order": 386,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB17-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB17",
      "fabric_code": "DB17-001",
      "web_name": "Beige Haven Linen",
      "name_key": "beige-haven-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjE3LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB17-1.jpg",
      "search_text": "DB17-001 Beige Haven Linen Budget Friendly",
      "sort_order": 387,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB17-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB17",
      "fabric_code": "DB17-002",
      "web_name": "Dune Shelter Linen",
      "name_key": "dune-shelter-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjE3LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB17-2.jpg",
      "search_text": "DB17-002 Dune Shelter Linen Budget Friendly",
      "sort_order": 388,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB17-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB17",
      "fabric_code": "DB17-003",
      "web_name": "Sandstone Calm Linen",
      "name_key": "sandstone-calm-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjE3LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB17-3.jpg",
      "search_text": "DB17-003 Sandstone Calm Linen Budget Friendly",
      "sort_order": 389,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB17-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB17",
      "fabric_code": "DB17-004",
      "web_name": "Clay Ember Linen",
      "name_key": "clay-ember-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjE3LTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB17-4.jpg",
      "search_text": "DB17-004 Clay Ember Linen Budget Friendly",
      "sort_order": 390,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB17-005",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB17",
      "fabric_code": "DB17-005",
      "web_name": "Walnut Crest Weave",
      "name_key": "walnut-crest-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjE3LTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB17-5.jpg",
      "search_text": "DB17-005 Walnut Crest Weave Budget Friendly",
      "sort_order": 391,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB17-006",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB17",
      "fabric_code": "DB17-006",
      "web_name": "Espresso Grove Weave",
      "name_key": "espresso-grove-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjE3LTYuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB17-6.jpg",
      "search_text": "DB17-006 Espresso Grove Weave Budget Friendly",
      "sort_order": 392,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB20-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB20",
      "fabric_code": "DB20-001",
      "web_name": "Silver Basket Weave",
      "name_key": "silver-basket-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIwLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB20-1.jpg",
      "search_text": "DB20-001 Silver Basket Weave Budget Friendly",
      "sort_order": 393,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB20-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB20",
      "fabric_code": "DB20-002",
      "web_name": "Steel Harbour Weave",
      "name_key": "steel-harbour-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIwLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB20-2.jpg",
      "search_text": "DB20-002 Steel Harbour Weave Budget Friendly",
      "sort_order": 394,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB22-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB22",
      "fabric_code": "DB22-001",
      "web_name": "Taupe Canyon Weave",
      "name_key": "taupe-canyon-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIyLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB22-1.jpg",
      "search_text": "DB22-001 Taupe Canyon Weave Budget Friendly",
      "sort_order": 395,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB22-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB22",
      "fabric_code": "DB22-002",
      "web_name": "Granite Coast Weave",
      "name_key": "granite-coast-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIyLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB22-2.jpg",
      "search_text": "DB22-002 Granite Coast Weave Budget Friendly",
      "sort_order": 396,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB22-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB22",
      "fabric_code": "DB22-003",
      "web_name": "Slate Summit Weave",
      "name_key": "slate-summit-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIyLTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB22-3.jpg",
      "search_text": "DB22-003 Slate Summit Weave Budget Friendly",
      "sort_order": 397,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB22-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB22",
      "fabric_code": "DB22-004",
      "web_name": "Pewter Ridge Weave",
      "name_key": "pewter-ridge-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIyLTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB22-4.jpg",
      "search_text": "DB22-004 Pewter Ridge Weave Budget Friendly",
      "sort_order": 398,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB22-005",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB22",
      "fabric_code": "DB22-005",
      "web_name": "Ocean Storm Weave",
      "name_key": "ocean-storm-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIyLTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB22-5.jpg",
      "search_text": "DB22-005 Ocean Storm Weave Budget Friendly",
      "sort_order": 399,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB23-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB23",
      "fabric_code": "DB23-001",
      "web_name": "Ivory Bloom Linen",
      "name_key": "ivory-bloom-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIzLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB23-1.jpg",
      "search_text": "DB23-001 Ivory Bloom Linen Budget Friendly",
      "sort_order": 400,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB23-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB23",
      "fabric_code": "DB23-002",
      "web_name": "Cream Dune Linen",
      "name_key": "cream-dune-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIzLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB23-2.jpg",
      "search_text": "DB23-002 Cream Dune Linen Budget Friendly",
      "sort_order": 401,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB23-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB23",
      "fabric_code": "DB23-003",
      "web_name": "Cloud Pearl Linen",
      "name_key": "cloud-pearl-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIzLTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB23-3.jpg",
      "search_text": "DB23-003 Cloud Pearl Linen Budget Friendly",
      "sort_order": 402,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB23-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB23",
      "fabric_code": "DB23-004",
      "web_name": "Silver Feather Linen",
      "name_key": "silver-feather-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIzLTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB23-4.jpg",
      "search_text": "DB23-004 Silver Feather Linen Budget Friendly",
      "sort_order": 403,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB23-005",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB23",
      "fabric_code": "DB23-005",
      "web_name": "Driftwood Trail Weave",
      "name_key": "driftwood-trail-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIzLTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB23-5.jpg",
      "search_text": "DB23-005 Driftwood Trail Weave Budget Friendly",
      "sort_order": 404,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB23-006",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 1",
      "collection_label": "Budget Friendly",
      "source_product_label": "Zebra Shades Blackout - Budget Friendly",
      "fabric_series": "DB23",
      "fabric_code": "DB23-006",
      "web_name": "Carbon Shadow Weave",
      "name_key": "carbon-shadow-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE3NzIyMDMxNzQwMy1EQjIzLTYuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9177220317403-DB23-6.jpg",
      "search_text": "DB23-006 Carbon Shadow Weave Budget Friendly",
      "sort_order": 405,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB6-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB6",
      "fabric_code": "DB6-001",
      "web_name": "Sandstone Glow Linen",
      "name_key": "sandstone-glow-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjYtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB6-1.jpg",
      "search_text": "DB6-001 Sandstone Glow Linen Residential Collection",
      "sort_order": 406,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB6-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB6",
      "fabric_code": "DB6-002",
      "web_name": "Sterling Soft Linen",
      "name_key": "sterling-soft-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjYtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB6-2.jpg",
      "search_text": "DB6-002 Sterling Soft Linen Residential Collection",
      "sort_order": 407,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB6-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB6",
      "fabric_code": "DB6-003",
      "web_name": "Cocoa Truffle Weave",
      "name_key": "cocoa-truffle-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjYtMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB6-3.jpg",
      "search_text": "DB6-003 Cocoa Truffle Weave Residential Collection",
      "sort_order": 408,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB7-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB7",
      "fabric_code": "DB7-001",
      "web_name": "Alpine White Linen",
      "name_key": "alpine-white-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjctMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB7-1.jpg",
      "search_text": "DB7-001 Alpine White Linen Residential Collection",
      "sort_order": 409,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB7-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB7",
      "fabric_code": "DB7-002",
      "web_name": "Glacier Frost Linen",
      "name_key": "glacier-frost-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjctMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB7-2.jpg",
      "search_text": "DB7-002 Glacier Frost Linen Residential Collection",
      "sort_order": 410,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB7-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB7",
      "fabric_code": "DB7-003",
      "web_name": "Ash Drift Linen",
      "name_key": "ash-drift-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjctMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB7-3.jpg",
      "search_text": "DB7-003 Ash Drift Linen Residential Collection",
      "sort_order": 411,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB7-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB7",
      "fabric_code": "DB7-004",
      "web_name": "Dune Cream Linen",
      "name_key": "dune-cream-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjctNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB7-4.jpg",
      "search_text": "DB7-004 Dune Cream Linen Residential Collection",
      "sort_order": 412,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB7-005",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB7",
      "fabric_code": "DB7-005",
      "web_name": "Walnut Ember Weave",
      "name_key": "walnut-ember-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjctNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB7-5.jpg",
      "search_text": "DB7-005 Walnut Ember Weave Residential Collection",
      "sort_order": 413,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB7-006",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB7",
      "fabric_code": "DB7-006",
      "web_name": "Onyx Midnight Weave",
      "name_key": "onyx-midnight-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjctNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB7-6.jpg",
      "search_text": "DB7-006 Onyx Midnight Weave Residential Collection",
      "sort_order": 414,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB9-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB9",
      "fabric_code": "DB9-001",
      "web_name": "Frost Peak Linen",
      "name_key": "frost-peak-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjktMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB9-1.jpg",
      "search_text": "DB9-001 Frost Peak Linen Residential Collection",
      "sort_order": 415,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB9-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB9",
      "fabric_code": "DB9-002",
      "web_name": "Pearl Stone Weave",
      "name_key": "pearl-stone-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjktMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB9-2.jpg",
      "search_text": "DB9-002 Pearl Stone Weave Residential Collection",
      "sort_order": 416,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB9-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB9",
      "fabric_code": "DB9-003",
      "web_name": "Linen Sandstone",
      "name_key": "linen-sandstone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjktMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB9-3.jpg",
      "search_text": "DB9-003 Linen Sandstone Residential Collection",
      "sort_order": 417,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB9-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB9",
      "fabric_code": "DB9-004",
      "web_name": "Granite Quarry Weave",
      "name_key": "granite-quarry-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjktNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB9-4.jpg",
      "search_text": "DB9-004 Granite Quarry Weave Residential Collection",
      "sort_order": 418,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB9-005",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB9",
      "fabric_code": "DB9-005",
      "web_name": "Driftwood Bark Weave",
      "name_key": "driftwood-bark-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjktNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB9-5.jpg",
      "search_text": "DB9-005 Driftwood Bark Weave Residential Collection",
      "sort_order": 419,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB9-006",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB9",
      "fabric_code": "DB9-006",
      "web_name": "Graphite Grain Texture",
      "name_key": "graphite-grain-texture",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjktNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182339596507-DB9-6.jpg",
      "search_text": "DB9-006 Graphite Grain Texture Residential Collection",
      "sort_order": 420,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB12-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB12",
      "fabric_code": "DB12-001",
      "web_name": "Arctic Glow Linen",
      "name_key": "arctic-glow-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjEyLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB12-1.jpg",
      "search_text": "DB12-001 Arctic Glow Linen Residential Collection",
      "sort_order": 421,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB12-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB12",
      "fabric_code": "DB12-002",
      "web_name": "Ivory Mist Linen",
      "name_key": "ivory-mist-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjEyLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB12-2.jpg",
      "search_text": "DB12-002 Ivory Mist Linen Residential Collection",
      "sort_order": 422,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB14-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB14",
      "fabric_code": "DB14-001",
      "web_name": "Rose Blush Weave",
      "name_key": "rose-blush-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE0LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB14-1.jpg",
      "search_text": "DB14-001 Rose Blush Weave Residential Collection",
      "sort_order": 423,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB14-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB14",
      "fabric_code": "DB14-002",
      "web_name": "Desert Pearl Linen",
      "name_key": "desert-pearl-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE0LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB14-2.jpg",
      "search_text": "DB14-002 Desert Pearl Linen Residential Collection",
      "sort_order": 424,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB14-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB14",
      "fabric_code": "DB14-003",
      "web_name": "Greige Silk Weave",
      "name_key": "greige-silk-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE0LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB14-3.jpg",
      "search_text": "DB14-003 Greige Silk Weave Residential Collection",
      "sort_order": 425,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB14-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB14",
      "fabric_code": "DB14-004",
      "web_name": "Shadow Line Weave",
      "name_key": "shadow-line-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE0LTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB14-4.jpg",
      "search_text": "DB14-004 Shadow Line Weave Residential Collection",
      "sort_order": 426,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB14-005",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB14",
      "fabric_code": "DB14-005",
      "web_name": "Cedar Grain Weave",
      "name_key": "cedar-grain-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE0LTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB14-5.jpg",
      "search_text": "DB14-005 Cedar Grain Weave Residential Collection",
      "sort_order": 427,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB14-006",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB14",
      "fabric_code": "DB14-006",
      "web_name": "Walnut Timber Grain",
      "name_key": "walnut-timber-grain",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE0LTYuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB14-6.jpg",
      "search_text": "DB14-006 Walnut Timber Grain Residential Collection",
      "sort_order": 428,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB14-007",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB14",
      "fabric_code": "DB14-007",
      "web_name": "Espresso Stripe Texture",
      "name_key": "espresso-stripe-texture",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE0LTcuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB14-7.jpg",
      "search_text": "DB14-007 Espresso Stripe Texture Residential Collection",
      "sort_order": 429,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB16-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB16",
      "fabric_code": "DB16-001",
      "web_name": "Snow Crystal Weave",
      "name_key": "snow-crystal-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE2LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB16-1.jpg",
      "search_text": "DB16-001 Snow Crystal Weave Residential Collection",
      "sort_order": 430,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB16-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB16",
      "fabric_code": "DB16-002",
      "web_name": "Linen Wheat Sand",
      "name_key": "linen-wheat-sand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE2LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB16-2.jpg",
      "search_text": "DB16-002 Linen Wheat Sand Residential Collection",
      "sort_order": 431,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB16-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB16",
      "fabric_code": "DB16-003",
      "web_name": "Granite Grid Texture",
      "name_key": "granite-grid-texture",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE2LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB16-3.jpg",
      "search_text": "DB16-003 Granite Grid Texture Residential Collection",
      "sort_order": 432,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB16-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB16",
      "fabric_code": "DB16-004",
      "web_name": "Mocha Roast Weave",
      "name_key": "mocha-roast-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE2LTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB16-4.jpg",
      "search_text": "DB16-004 Mocha Roast Weave Residential Collection",
      "sort_order": 433,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB18-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB18",
      "fabric_code": "DB18-001",
      "web_name": "Pearl Sheen Texture",
      "name_key": "pearl-sheen-texture",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE4LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB18-1.jpg",
      "search_text": "DB18-001 Pearl Sheen Texture Residential Collection",
      "sort_order": 434,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB18-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB18",
      "fabric_code": "DB18-002",
      "web_name": "Silver Crest Weave",
      "name_key": "silver-crest-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE4LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB18-2.jpg",
      "search_text": "DB18-002 Silver Crest Weave Residential Collection",
      "sort_order": 435,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB18-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB18",
      "fabric_code": "DB18-003",
      "web_name": "Sandstone Pearl Weave",
      "name_key": "sandstone-pearl-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE4LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB18-3.jpg",
      "search_text": "DB18-003 Sandstone Pearl Weave Residential Collection",
      "sort_order": 436,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB18-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB18",
      "fabric_code": "DB18-004",
      "web_name": "Charcoal Depth Weave",
      "name_key": "charcoal-depth-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE4LTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB18-4.jpg",
      "search_text": "DB18-004 Charcoal Depth Weave Residential Collection",
      "sort_order": 437,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB19-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB19",
      "fabric_code": "DB19-001",
      "web_name": "Silver Horizon Texture",
      "name_key": "silver-horizon-texture",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE5LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB19-1.jpg",
      "search_text": "DB19-001 Silver Horizon Texture Residential Collection",
      "sort_order": 438,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB19-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB19",
      "fabric_code": "DB19-002",
      "web_name": "Pebble Stream Texture",
      "name_key": "pebble-stream-texture",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE5LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB19-2.jpg",
      "search_text": "DB19-002 Pebble Stream Texture Residential Collection",
      "sort_order": 439,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB19-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB19",
      "fabric_code": "DB19-003",
      "web_name": "Bark Earth Texture",
      "name_key": "bark-earth-texture",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjE5LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB19-3.jpg",
      "search_text": "DB19-003 Bark Earth Texture Residential Collection",
      "sort_order": 440,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB21-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB21",
      "fabric_code": "DB21-001",
      "web_name": "Snowfall White Linen",
      "name_key": "snowfall-white-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjIxLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB21-1.jpg",
      "search_text": "DB21-001 Snowfall White Linen Residential Collection",
      "sort_order": 441,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB21-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB21",
      "fabric_code": "DB21-002",
      "web_name": "Frost Beam Weave",
      "name_key": "frost-beam-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjIxLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB21-2.jpg",
      "search_text": "DB21-002 Frost Beam Weave Residential Collection",
      "sort_order": 442,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB21-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB21",
      "fabric_code": "DB21-003",
      "web_name": "Ivory Sand Linen",
      "name_key": "ivory-sand-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjIxLTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB21-3.jpg",
      "search_text": "DB21-003 Ivory Sand Linen Residential Collection",
      "sort_order": 443,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB21-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB21",
      "fabric_code": "DB21-004",
      "web_name": "Dove Silver Weave",
      "name_key": "dove-silver-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjIxLTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB21-4.jpg",
      "search_text": "DB21-004 Dove Silver Weave Residential Collection",
      "sort_order": 444,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB21-005",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Zebra Shades Blackout - Residential Collection",
      "fabric_series": "DB21",
      "fabric_code": "DB21-005",
      "web_name": "Mocha Earth Weave",
      "name_key": "mocha-earth-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjMzOTU5NjUwNy1EQjIxLTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182339596507-DB21-5.jpg",
      "search_text": "DB21-005 Mocha Earth Weave Residential Collection",
      "sort_order": 445,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB2-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Blackout - Premium Collection",
      "fabric_series": "DB2",
      "fabric_code": "DB2-001",
      "web_name": "Snow Drift Linen",
      "name_key": "snow-drift-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM0NjQxMjI1MS1EQjItMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182346412251-DB2-1.jpg",
      "search_text": "DB2-001 Snow Drift Linen Premium Collection",
      "sort_order": 446,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB2-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Blackout - Premium Collection",
      "fabric_series": "DB2",
      "fabric_code": "DB2-002",
      "web_name": "Ivory Glow Linen",
      "name_key": "ivory-glow-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM0NjQxMjI1MS1EQjItMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182346412251-DB2-2.jpg",
      "search_text": "DB2-002 Ivory Glow Linen Premium Collection",
      "sort_order": 447,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB2-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Blackout - Premium Collection",
      "fabric_series": "DB2",
      "fabric_code": "DB2-003",
      "web_name": "Natural Sand Dune Linen",
      "name_key": "natural-sand-dune-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM0NjQxMjI1MS1EQjItMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182346412251-DB2-3.jpg",
      "search_text": "DB2-003 Natural Sand Dune Linen Premium Collection",
      "sort_order": 448,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB2-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Blackout - Premium Collection",
      "fabric_series": "DB2",
      "fabric_code": "DB2-004",
      "web_name": "Silver Cloud Linen",
      "name_key": "silver-cloud-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM0NjQxMjI1MS1EQjItNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182346412251-DB2-4.jpg",
      "search_text": "DB2-004 Silver Cloud Linen Premium Collection",
      "sort_order": 449,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB2-005",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Blackout - Premium Collection",
      "fabric_series": "DB2",
      "fabric_code": "DB2-005",
      "web_name": "Graphite Core Linen",
      "name_key": "graphite-core-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM0NjQxMjI1MS1EQjItNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182346412251-DB2-5.jpg",
      "search_text": "DB2-005 Graphite Core Linen Premium Collection",
      "sort_order": 450,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB8-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Blackout - Premium Collection",
      "fabric_series": "DB8",
      "fabric_code": "DB8-001",
      "web_name": "Arctic Pearl Linen",
      "name_key": "arctic-pearl-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM0NjQxMjI1MS1EQjgtMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182346412251-DB8-1.jpg",
      "search_text": "DB8-001 Arctic Pearl Linen Premium Collection",
      "sort_order": 451,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB8-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Blackout - Premium Collection",
      "fabric_series": "DB8",
      "fabric_code": "DB8-002",
      "web_name": "Frosted Silk Linen",
      "name_key": "frosted-silk-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM0NjQxMjI1MS1EQjgtMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182346412251-DB8-2.jpg",
      "search_text": "DB8-002 Frosted Silk Linen Premium Collection",
      "sort_order": 452,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB8-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Blackout - Premium Collection",
      "fabric_series": "DB8",
      "fabric_code": "DB8-003",
      "web_name": "Pearl Dawn Linen",
      "name_key": "pearl-dawn-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM0NjQxMjI1MS1EQjgtMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182346412251-DB8-3.jpg",
      "search_text": "DB8-003 Pearl Dawn Linen Premium Collection",
      "sort_order": 453,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB8-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Blackout - Premium Collection",
      "fabric_series": "DB8",
      "fabric_code": "DB8-004",
      "web_name": "Slate River Texture",
      "name_key": "slate-river-texture",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM0NjQxMjI1MS1EQjgtNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182346412251-DB8-4.jpg",
      "search_text": "DB8-004 Slate River Texture Premium Collection",
      "sort_order": 454,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB8-005",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 3",
      "collection_label": "Premium Collection",
      "source_product_label": "Zebra Shades Blackout - Premium Collection",
      "fabric_series": "DB8",
      "fabric_code": "DB8-005",
      "web_name": "Carbon Wood Texture",
      "name_key": "carbon-wood-texture",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM0NjQxMjI1MS1EQjgtNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9182346412251-DB8-5.jpg",
      "search_text": "DB8-005 Carbon Wood Texture Premium Collection",
      "sort_order": 455,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB10-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Blackout - Luxury Collection",
      "fabric_series": "DB10",
      "fabric_code": "DB10-001",
      "web_name": "Snow Quartz Linen",
      "name_key": "snow-quartz-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM1NTQ4ODk4Ny1EQjEwLTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182355488987-DB10-1.jpg",
      "search_text": "DB10-001 Snow Quartz Linen Luxury Collection",
      "sort_order": 456,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB10-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Blackout - Luxury Collection",
      "fabric_series": "DB10",
      "fabric_code": "DB10-002",
      "web_name": "Ivory Wheat Linen",
      "name_key": "ivory-wheat-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM1NTQ4ODk4Ny1EQjEwLTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182355488987-DB10-2.jpg",
      "search_text": "DB10-002 Ivory Wheat Linen Luxury Collection",
      "sort_order": 457,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB10-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Blackout - Luxury Collection",
      "fabric_series": "DB10",
      "fabric_code": "DB10-003",
      "web_name": "Silver Whisper Linen",
      "name_key": "silver-whisper-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM1NTQ4ODk4Ny1EQjEwLTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182355488987-DB10-3.jpg",
      "search_text": "DB10-003 Silver Whisper Linen Luxury Collection",
      "sort_order": 458,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB10-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Blackout - Luxury Collection",
      "fabric_series": "DB10",
      "fabric_code": "DB10-004",
      "web_name": "Stone Veil Linen",
      "name_key": "stone-veil-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM1NTQ4ODk4Ny1EQjEwLTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182355488987-DB10-4.jpg",
      "search_text": "DB10-004 Stone Veil Linen Luxury Collection",
      "sort_order": 459,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB15-001",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Blackout - Luxury Collection",
      "fabric_series": "DB15",
      "fabric_code": "DB15-001",
      "web_name": "Frost White Linen",
      "name_key": "frost-white-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM1NTQ4ODk4Ny1EQjE1LTEuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182355488987-DB15-1.jpg",
      "search_text": "DB15-001 Frost White Linen Luxury Collection",
      "sort_order": 460,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB15-002",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Blackout - Luxury Collection",
      "fabric_series": "DB15",
      "fabric_code": "DB15-002",
      "web_name": "Pearl White Linen",
      "name_key": "pearl-white-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM1NTQ4ODk4Ny1EQjE1LTIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182355488987-DB15-2.jpg",
      "search_text": "DB15-002 Pearl White Linen Luxury Collection",
      "sort_order": 461,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB15-003",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Blackout - Luxury Collection",
      "fabric_series": "DB15",
      "fabric_code": "DB15-003",
      "web_name": "Sand Dune Linen",
      "name_key": "sand-dune-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM1NTQ4ODk4Ny1EQjE1LTMuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182355488987-DB15-3.jpg",
      "search_text": "DB15-003 Sand Dune Linen Luxury Collection",
      "sort_order": 462,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB15-004",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Blackout - Luxury Collection",
      "fabric_series": "DB15",
      "fabric_code": "DB15-004",
      "web_name": "Ash Silver Texture",
      "name_key": "ash-silver-texture",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM1NTQ4ODk4Ny1EQjE1LTQuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182355488987-DB15-4.jpg",
      "search_text": "DB15-004 Ash Silver Texture Luxury Collection",
      "sort_order": 463,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    },
    {
      "id": "zebra-blackout-DB15-005",
      "roller_type": "zebra",
      "shade_type": "blackout",
      "swatch_product_key": "zebra-blackout",
      "tier": "Tier 4",
      "collection_label": "Luxury Collection",
      "source_product_label": "Zebra Shades Blackout - Luxury Collection",
      "fabric_series": "DB15",
      "fabric_code": "DB15-005",
      "web_name": "Graphite Thread Texture",
      "name_key": "graphite-thread-texture",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE4MjM1NTQ4ODk4Ny1EQjE1LTUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMDAsImZpdCI6ImNvbnRhaW4ifX19",
      "image_filename": "9182355488987-DB15-5.jpg",
      "search_text": "DB15-005 Graphite Thread Texture Luxury Collection",
      "sort_order": 464,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "matched"
    }
  ]
};
